module.exports = __webpack_public_path__ + "img/ckgjcr.0b1e7c6f.png";